import { Moon, Zap, Wind, Apple, User, Sparkles } from 'lucide-react';
import FeatureCard from './FeatureCard';

export default function FeaturesSection() {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-primary-200/30 to-secondary-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-tl from-secondary-200/30 to-primary-200/30 rounded-full blur-3xl"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-primary-100 to-secondary-100 px-4 py-2 rounded-full mb-6 border border-primary-200">
            <Sparkles className="w-4 h-4 text-secondary-600" />
            <span className="text-sm font-medium text-primary-700">Fonctionnalités principales</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-primary-800 to-secondary-700 bg-clip-text text-transparent">
              Tout ce dont vous avez besoin
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Une approche complète du bien-être qui s'adapte à votre rythme de vie
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <FeatureCard
            icon={<Moon className="w-8 h-8" />}
            title="Méditations guidées"
            description="Améliorez votre sommeil, votre confiance en soi, votre gestion du stress et bien plus encore avec plus de 150 méditations."
          />
          <FeatureCard
            icon={<Zap className="w-8 h-8" />}
            title="Hypnose et motivation"
            description="Reprogrammez votre inconscient pour libérer ce qui vous freine en profondeur."
          />
          <FeatureCard
            icon={<Wind className="w-8 h-8" />}
            title="Respiration et affirmations positives"
            description="Retrouvez votre calme par des exercices de respiration et contrôlez vos pensées grâce aux affirmations."
          />
          <FeatureCard
            icon={<Apple className="w-8 h-8" />}
            title="Nutrition saine"
            description="Laissez votre alimentation devenir votre meilleure alliée bien-être avec des recettes adaptées à vos objectifs."
          />
          <FeatureCard
            icon={<User className="w-8 h-8" />}
            title="Programme personnalisé"
            description="Un accompagnement sur mesure pour vos défis personnels en répondant à un simple questionnaire."
          />
          <FeatureCard
            icon={<Sparkles className="w-8 h-8" />}
            title="Révolution WeZen"
            description="Défis, suivi de l'humeur, articles, personnalisation des méditations ( voix et son d'ambiance ), etc…"
          />
        </div>
      </div>
    </section>
  );
}
